module.exports = __webpack_public_path__ + "media/images/usersIcon-76a74f13.svg";